import useHandleAppException from '../../../../../../hooks/useHandleAppException';
import LangEnum from '../../../../../../lang/LangEnum';
import snackbarStore from '../../../../../../stores/Snackbar.store';
import { useTranslation } from '../../../../../translation/TranslationContext';

const useHandleUpdateKitOnOrderErrorResponse = () => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;
  const { handleErrorResponse } = useHandleAppException();

  const handleError = (err: any) => {
    if (err instanceof Error) {
      const error = JSON.parse(err.message);
      const messageCode = error?.code || error.data?.code;

      const message = handleErrorResponse({ ok: false, data: { ...error, code: messageCode } });
      handleMessage({
        type: 'error',
        message,
      });
      return;
    } else if (err?.code && err?.message) {
      const message = handleErrorResponse({ ok: false, data: { ...err, code: err.code } });
      handleMessage({
        type: 'error',
        message,
      });
      return;
    }

    handleMessage({
      type: 'error',
      message: translate(LangEnum.ERROR_UPDATING_ITEM_MESSAGE),
    });
  };

  return { handleError };
};

export default useHandleUpdateKitOnOrderErrorResponse;
